import { render, staticRenderFns } from "./migrationpinjamandebitur.vue?vue&type=template&id=0771b12c&scoped=true&"
import script from "./migrationpinjamandebitur.vue?vue&type=script&lang=js&"
export * from "./migrationpinjamandebitur.vue?vue&type=script&lang=js&"
import style0 from "./migrationpinjamandebitur.vue?vue&type=style&index=0&id=0771b12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771b12c",
  null
  
)

export default component.exports